import SingleCoinView from "../views/SingleCoinView";

export default function CoinPage() {
  return (
    <div>
      <SingleCoinView />
    </div>
  );
}
